import { render, staticRenderFns } from "./PIModel1.vue?vue&type=template&id=ef71a668&scoped=true"
import script from "./PIModel1.vue?vue&type=script&lang=js"
export * from "./PIModel1.vue?vue&type=script&lang=js"
import style0 from "./PIModel1.vue?vue&type=style&index=0&id=ef71a668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef71a668",
  null
  
)

export default component.exports